<div class="container">
    <div class="premium-access-content">
        <span class="sub-title">Certificazione affidabile</span>
        <h2>Ottieni il tuo certificato di abilità di qualità attraverso l'esame online o in sede</h2>
        <p>i nostri prezzi convenienti per gli studenti per i programmi di certificazione aiutano le persone a ottenere il loro certificato di abilità</p>
        <a routerLink="/elenco-corsi" class="default-btn"><i class="flaticon-user"></i>Inizia Ora<span></span></a>
    </div>
</div>
